export const SETTING_CONSTANTS = {
  TABS: {
    GENERAL: 'General',
    USERS_AND_ACCESS: 'UsersAndAccess',
    USER: 'User',
    SSO: 'SSO',
    NOTIFICATIONS: 'Notifications',
    INTEGRATIONS: 'integrations',
    WEBHOOKS: 'Webhooks'
  },
  NOTIFICATIONS_TABS: {
    ALL: 'All',
    ASSET_ANALYSIS: 'Asset Analysis',
    SECURITY_FINDINGS: 'Security Findings',
    SETTINGS_AND_ADMINISTRATION: 'Settings & Administration',
    VULNERABILITY: 'Vulnerability'
  },
  USERS_AND_ACCESS_TABS: {
    USER_MANAGEMENT: 'User Management',
    SECURITY_GROUPS: 'Security Groups',
    ROLES: 'Roles',
    ACCESS_CONTROL: 'Access Control'
  },
  LABELS: {
    USER_MANAGEMENT: 'User Management',
    USERS_AND_ACCESS: 'Users & Access',
    INTEGRATIONS: 'Integrations'
  }
};
